module.exports = __webpack_public_path__ + "static/media/Ekstra-Tugas.f3512677.png";